import React from "react"
import { graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import "./_style.scss"

import Layout from "§/src/components/layout"
import Breadcrumb from "§/src/components/atoms/breadcrumb/breadcrumb"
import BreadcrumbCustomLevels from "§/src/components/atoms/breadcrumb/breadcrumb-customlevels"
import SchemaBreadcrumb from "§/src/components/schema/s-breadcrumb"

import Error from "§/src/components/error"
import SEO from "§/src/components/seo"
import LoadingFrame from "§/src/components/atoms/loading-frame"

// Functions
import { isEmpty } from "lodash"

import Layouter from "§/src/components/sections/layouter"
const CaseHistoryCarousel = React.lazy(() =>
  import("§/src/components/sections/case-history-carousel")
)

// Switch Language
import { useTranslation } from "react-i18next"
import { getFormattedLanguage } from "§/src/utils/functions"

export function Head(props) {
  const seo = props?.pageContext?.seo || {}

  return (
    <React.Fragment>
      <html lang={getFormattedLanguage(process.env.GATSBY_SITE_LANG)}></html>
      <body className="temp-blank"></body>
      <SEO seo={seo} translations={props?.data?.lang?.translations} />
      <SchemaBreadcrumb breadcrumbs={seo?.breadcrumbs} />
    </React.Fragment>
  )
}

const TemplateGroup = props => {
  const { t } = useTranslation()
  const data = props?.pageContext?.acfPages_blank
  const compLayouter = translateToNewFormat(data?.layouter)
  const compRelated = data?.related
  const compRelatedTitle = data?.relatedTitle
  const compTitle = data?.enableTitle
  const breadcrumbsType = data?.breadcrumbsType ?? "default"

  return (
    <Layout lang={props?.data?.lang?.translations}>
      {
        // switch statement for breadcrumbsType
        {
          "no-parents-links": (
            <BreadcrumbCustomLevels
              levels="1"
              wpseo={props?.pageContext?.seo?.breadcrumbs}
            />
          ),
        }[breadcrumbsType] ||
          {
            "support-downloads": (
              <BreadcrumbCustomLevels
                base={t("Supporto e rete vendita")}
                wpseo={props?.pageContext?.seo?.breadcrumbs}
              />
            ),
          }[breadcrumbsType] || (
            // default:
            <Breadcrumb wpseo={props?.pageContext?.seo?.breadcrumbs} />
          )
      }

      {!isEmpty(props?.pageContext) ? (
        <React.Suspense fallback={<LoadingFrame />}>
          {compTitle && (
            <div id="downloads-title">
              <div className="text-container">
                <h1 className="title">{props?.pageContext?.title}</h1>
                <div className="readmore">
                  {props?.pageContext?.content?.replace(/(<([^>]+)>)/gi, "")}
                </div>
              </div>
            </div>
          )}
          {compLayouter && <Layouter data={compLayouter} />}
          {compRelated && (
            <CaseHistoryCarousel
              data={compRelated}
              title={compRelatedTitle || ""}
              filter="false"
            />
          )}
        </React.Suspense>
      ) : (
        <Error message="Something Went Wrong" />
      )}
    </Layout>
  )
}

export default TemplateGroup

export const pageQuery = graphql`
  query GET_TRANSLATIONS($eq: String!) {
    lang: wpPage(slug: { eq: $eq }) {
      translations {
        postUrl
        siteId
      }
    }
  }
`

const translateToNewFormat = data => {
  data = [...data]
  for (const elem of data) {
    if (elem && elem.downloadFiles) {
      elem.downloadFiles = elem.downloadFiles.map(x => ({
        title: x.title,
        fieldGroupName: x.fieldGroupName,
        files: [{ ...x.file, title: x.title }],
        file: { ...x.file, title: x.title },
      }))
    }
    if (elem && elem.downloads && elem.downloads.downloadFiles) {
      elem.downloads.downloadFiles = elem.downloads.downloadFiles.map(x => ({
        title: x.title,
        fieldGroupName: x.fieldGroupName,
        files: [{ ...x.file, title: x.title }],
        file: { ...x.file, title: x.title },
      }))
    }
  }
  return data
}
